module.exports = __webpack_public_path__ + "img/photo-21.2001f119.jpg";